import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function ProductPresentation() {
  const benefits = ['Oltre 50 ricette testate e perfezionate', 'Plumcake classici, marmorizzati, alla frutta e speziati', 'Ideali per colazione, merenda o dessert', 'Ingredienti semplici e facili da trovare', 'Tecniche per ottenere plumcake soffici e perfetti ogni volta'];
  return <section className="py-16 px-4 bg-white" data-id="element-236">
      <div className="max-w-4xl mx-auto" data-id="element-237">
        <div className="text-center mb-10" data-id="element-238">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-239">
            Questo libro digitale ti insegna:
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-240">
            Passo dopo passo come preparare plumcake soffici, umidi e pieni di
            sapore, anche se non hai mai fatto dolci.
          </p>
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-3xl border border-blue-100 p-6 md:p-10 shadow-lg" data-id="element-241">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-242">
            {benefits.map((benefit, index) => <div key={index} className={`flex items-start gap-3 p-4 bg-white rounded-2xl shadow-sm ${index === benefits.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto w-full' : ''}`} data-id="element-243">
                <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-244" />
                <span className="text-gray-800 font-medium" data-id="element-245">{benefit}</span>
              </div>)}
          </div>

          <p className="text-center text-lg text-gray-700 italic font-medium" data-id="element-246">
            Con ricette facili, chiare e testate per riuscire sempre al primo
            tentativo.
          </p>
        </div>
      </div>
    </section>;
}